module.exports = __webpack_public_path__ + "img/instagram.deb094cb.svg";